import { UtilForms } from './utils/util-forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import localePt from '@angular/common/locales/pt';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData, PathLocationStrategy, LocationStrategy } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ImageCropperModule } from 'ngx-image-cropper';


import {
  NgbDropdownModule,
  NgbDatepickerModule,
  NgbDateParserFormatter,
  NgbModalModule,
  NgbPaginationModule,
  NgbTypeaheadModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SideMenuComponent } from './navigation/side-menu/side-menu.component';
import { BrandLogoComponent } from './navigation/brand-logo/brand-logo.component';
import { SideNavItemComponent } from './navigation/side-menu/components/side-nav-item/side-nav-item.component';
import { SideNavDropdownComponent } from './navigation/side-menu/components/side-nav-dropdown/side-nav-dropdown.component';
import { TopMenuComponent } from './navigation/top-menu/top-menu.component';
import { AppCheckboxComponent } from './app-components/app-checkbox/app-checkbox.component';
import { HomeComponent } from './app-views/home/home.component';
import { AppInputRadioComponent } from './app-components/app-input-radio/app-input-radio.component';
import { RealizarConsultaComponent } from './app-views/consulta/realizar-consulta/realizar-consulta.component';
import { AppInputToggleComponent } from './app-components/app-input-toggle/app-input-toggle.component';
import { FormConsultaCompostaComponent } from './app-views/consulta/form-consulta-composta/form-consulta-composta.component';
import { ListConsultaCompostaComponent } from './app-views/consulta/list-consulta-composta/list-consulta-composta.component';
import { ListHistoricoConsultaComponent } from './app-views/consulta/list-historico-consulta/list-historico-consulta.component';
import { NgbDateBrParserFormatter } from './utils/ngb-date-br-parser-formatter';
import { LoginComponent } from './app-views/login/login.component';
import { ModalSenhaExpiradaComponent } from './app-views/login/modal-senha-expirada/modal-senha-expirada.component';

import { RecuperarSenhaComponent } from './app-views/login/recuperar-senha/recuperar-senha.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpClientInterceptor } from './services/http-client-interceptor.service';
import { LoginService } from './services/login.service';
import { FormRealizarConsultaComponent } from './app-views/consulta/realizar-consulta/form-realizar-consulta/form-realizar-consulta.component';
import { MsgErroComponent } from './app-components/msg-erro/msg-erro.component';
import { ModalFormRealizarConsultaComponent } from './app-views/consulta/realizar-consulta/modal-form-realizar-consulta/modal-form-realizar-consulta.component';
import { ModalLoadingComponent } from './app-components/modal-loading/modal-loading.component';
import { ModalMsgComponent } from './app-components/modal-msg/modal-msg.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ModalJustificativaComponent } from './app-components/modal-justificativa/modal-justificativa.component';
import { ResgateConsultaComponent } from './app-views/consulta/resgate-consulta/resgate-consulta.component';
import { FormUnidadeComponent } from './app-views/unidade/form-unidade/form-unidade.component';
import { EnderecoService } from './services/http/endereco.service';
import { ListUnidadeComponent } from './app-views/unidade/list-unidade/list-unidade.component';
import { ListUsuarioComponent } from './app-views/usuario/list-usuario/list-usuario.component';
import { FormUsuarioComponent } from './app-views/usuario/form-usuario/form-usuario.component';
import { FormNovaSenhaComponent } from './app-views/usuario/form-nova-senha/form-nova-senha.component';
import { ListTipoUnidadeComponent } from './app-views/unidade/list-tipo-unidade/list-tipo-unidade.component';
import { FormTipoUnidadeComponent } from './app-views/unidade/form-tipo-unidade/form-tipo-unidade.component';
import { ConsultaResultadoComponent } from './app-views/consulta-resultado/consulta-resultado.component';
import { ResumoDecisaoCertaComponent } from './app-views/consulta-resultado/resumo-decisao-certa/resumo-decisao-certa.component';
import { CardConsultaComponent } from './app-views/consulta-resultado/card-consulta/card-consulta.component';
import { ConsultaAgregadosComponent } from './app-views/consulta-resultado/consultas/consulta-agregados/consulta-agregados.component';
import { ConsultaDadosEstaduaisComponent } from './app-views/consulta-resultado/consultas/consulta-dados-estaduais/consulta-dados-estaduais.component';
import { ConsultaDadosNacionaisComponent } from './app-views/consulta-resultado/consultas/consulta-dados-nacionais/consulta-dados-nacionais.component';
import { ConsultaDadosRenajudComponent } from './app-views/consulta-resultado/consultas/consulta-dados-renajud/consulta-dados-renajud.component';
import { ConsultaDecodificadorChassiComponent } from './app-views/consulta-resultado/consultas/consulta-decodificador-chassi/consulta-decodificador-chassi.component';
import { ConsultaGravameComponent } from './app-views/consulta-resultado/consultas/consulta-gravame/consulta-gravame.component';
import { ConsultaHistoricoProprietarioComponent } from './app-views/consulta-resultado/consultas/consulta-historico-proprietario/consulta-historico-proprietario.component';
import { ConsultaHistoricoProprietarioSimplificadoComponent } from './app-views/consulta-resultado/consultas/consulta-historico-proprietario-simplificado/consulta-historico-proprietario-simplificado.component';
import { ConsultaHistoricoVendaComponent } from './app-views/consulta-resultado/consultas/consulta-historico-venda/consulta-historico-venda.component';
import { ConsultaRouboFurtoComponent } from './app-views/consulta-resultado/consultas/consulta-roubo-furto/consulta-roubo-furto.component';
import { ConsultaIndicioSinistroComponent } from './app-views/consulta-resultado/consultas/consulta-indicio-sinistro/consulta-indicio-sinistro.component';
import { ConsultaDuplicidadeChassiMotorComponent } from './app-views/consulta-resultado/consultas/consulta-duplicidade-chassi-motor/consulta-duplicidade-chassi-motor.component';
import { ConsultaLocalizaPlacaComponent } from './app-views/consulta-resultado/consultas/consulta-localiza-placa/consulta-localiza-placa.component';
import { ConsultaPrecificadorComponent } from './app-views/consulta-resultado/consultas/consulta-precificador/consulta-precificador.component';
import { ConsultaRecallComponent } from './app-views/consulta-resultado/consultas/consulta-recall/consulta-recall.component';
import { ConsultaRenavamComponent } from './app-views/consulta-resultado/consultas/consulta-renavam/consulta-renavam.component';
import { SinalizadorNivelComponent } from './app-components/sinalizador-nivel/sinalizador-nivel.component';
import { ConsultaLeilaoComponent } from './app-views/consulta-resultado/consultas/consulta-leilao/consulta-leilao.component';
import { ConsultaLeilaoComplementarComponent } from './app-views/consulta-resultado/consultas/consulta-leilao-complementar/consulta-leilao-complementar.component';
import { ConsultaPrecoMolicarComponent } from './app-views/consulta-resultado/consultas/consulta-preco-molicar/consulta-preco-molicar.component';
import { ConsultaPrecoKbbComponent } from './app-views/consulta-resultado/consultas/consulta-preco-kbb/consulta-preco-kbb.component';
import { ConsultaPrecoWebmotorsComponent } from './app-views/consulta-resultado/consultas/consulta-preco-webmotors/consulta-preco-webmotors.component';
import { ConsultaDesvalorizacaoMediaComponent } from './app-views/consulta-resultado/consultas/consulta-desvalorizacao-media/consulta-desvalorizacao-media.component';
import { ConsultaParecerTecnicoComponent } from './app-views/consulta-resultado/consultas/consulta-parecer-tecnico/consulta-parecer-tecnico.component';
import { ConsultaGenericaComponent } from './app-views/consulta-resultado/consultas/consulta-generica/consulta-generica.component';
import { ConsultaCnhComponent } from './app-views/consulta-resultado/consultas/consulta-cnh/consulta-cnh.component';
import { ConsultaCrlvComponent } from './app-views/consulta-resultado/consultas/consulta-crlv/consulta-crlv.component';
import { ConsultaDadosHistoricoComponent } from './app-views/consulta-resultado/consultas/consulta-dados-historico/consulta-dados-historico.component';
import { TableTitleOrderComponent } from './app-components/table-title-order/table-title-order.component';
import { RelatorioProducaoComponent } from './app-views/relatorio/relatorio-producao/relatorio-producao.component';
import { RelatorioUnidadeComponent } from './app-views/relatorio/relatorio-unidade/relatorio-unidade.component';
import { RelatorioWebSocketComponent } from './app-views/relatorio/relatorio-web-socket/relatorio-web-socket.component';
import { RelatorioConsultasRealizadasComponent } from './app-views/relatorio/relatorio-consultas-realizadas/relatorio-consultas-realizadas.component';
import { ConsultaPtComponent } from './app-views/consulta-resultado/consultas/consulta-pt/consulta-pt.component';
import { ConsultaLocalizadorVeiculoComponent } from './app-views/consulta-resultado/consultas/consulta-localizador-veiculo/consulta-localizador-veiculo.component';
import { ConsultaMultaRenainfComponent } from './app-views/consulta-resultado/consultas/consulta-multa-renainf/consulta-multa-renainf.component';
import { UploadLaudoComponent } from './app-views/laudo-carsys/upload-laudo/upload-laudo.component';
import { ListLaudoCarsysComponent } from './app-views/laudo-carsys/list-laudo-carsys/list-laudo-carsys.component';
import { FormTabelaPrecoComponent } from './app-views/tabela-preco/form-tabela-preco/form-tabela-preco.component';
import { ListTabelaPrecoComponent } from './app-views/tabela-preco/list-tabela-preco/list-tabela-preco.component';
import { ListTabelaPrecoLaudoComponent } from './app-views/tabela-preco/list-tabela-preco-laudo/list-tabela-preco-laudo.component';
import { FormTabelaPrecoLaudoComponent } from './app-views/tabela-preco/form-tabela-preco-laudo/form-tabela-preco-laudo.component';
import { InputRangeQuantidadePrecoComponent } from './app-views/tabela-preco/input-range-quantidade-preco/input-range-quantidade-preco.component';
import { ListConsultaLoteComponent } from './app-views/consulta/list-consulta-lote/list-consulta-lote.component';
import { FormConsultaLoteComponent } from './app-views/consulta/form-consulta-lote/form-consulta-lote.component';
import { VisualizarConsultaLoteComponent } from './app-views/consulta/visualizar-consulta-lote/visualizar-consulta-lote.component';
import { StepByStepComponent } from './app-views/laudo-union/components/step-by-step/step-by-step.component';
import { FormLaudoComponent } from './app-views/laudo-union/form-laudo/form-laudo.component';
import { ImageEditorComponent } from './app-views/laudo-union/components/image-editor/image-editor.component';
import { ImageEditorModalComponent } from './app-views/laudo-union/components/image-editor/image-editor-modal/image-editor-modal.component';
import { InputFileComponent } from './app-views/laudo-union/components/input-file/input-file.component';
import { InputImgLaudoComponent } from './app-views/laudo-union/components/input-img-laudo/input-img-laudo.component';
import { InputTextLaudoComponent } from './app-views/laudo-union/components/input-text-laudo/input-text-laudo.component';
import { InputSelectLaudoComponent } from './app-views/laudo-union/components/input-select-laudo/input-select-laudo.component';
import { CardCollapseComponent } from './app-components/card-collapse/card-collapse.component';
import { ListLaudoUnionComponent } from './app-views/laudo-union/list-laudo-union/list-laudo-union.component';
import { ListConfigLaudoUnionComponent } from './app-views/laudo-union/list-config-laudo-union/list-config-laudo-union.component';
import { FormConfigLaudoUnionComponent } from './app-views/laudo-union/form-config-laudo-union/form-config-laudo-union.component';
import { ListLaudosAgendadosComponent } from './app-views/laudo-union/list-laudos-agendados/list-laudos-agendados.component';
import { FormAgendamentoLaudoUnionComponent } from './app-views/laudo-union/form-agendamento-laudo-union/form-agendamento-laudo-union.component';
import { FormNovoLaudoComponent } from './app-views/laudo-union/form-laudo/form-novo-laudo/form-novo-laudo.component';
import { FormImgLaudoComponent } from './app-views/laudo-union/form-laudo/form-img-laudo/form-img-laudo.component';
import { FormAssociacaoAuditoriaComponent } from './app-views/auditoria/form-associacao-auditoria/form-associacao-auditoria.component';
import { ListAssociacaoAuditoriaComponent } from './app-views/auditoria/list-associacao-auditoria/list-associacao-auditoria.component';
import { ListUnidadesAuditadasComponent } from './app-views/auditoria/list-unidades-auditadas/list-unidades-auditadas.component';
import { ListNovaAssociacaoAuditoraComponent } from './app-views/auditoria/list-nova-associacao-auditora/list-nova-associacao-auditora.component';
import { AuditarLaudoAuditoriaComponent } from './app-views/auditoria/auditar-laudo-auditoria/auditar-laudo-auditoria.component';
import { TemplateBuilderComponent } from './app-views/laudo-union/components/template-builder/template-builder.component';
import { ElementTemplateBuilderComponent } from './app-views/laudo-union/components/template-builder/element-template-builder/element-template-builder.component';
import { FormModalImgLaudoComponent } from './app-views/laudo-union/form-laudo/form-modal-img-laudo/form-modal-img-laudo.component';
import { FormImgAdicionalLaudoComponent } from './app-views/laudo-union/form-laudo/form-img-adicional-laudo/form-img-adicional-laudo.component';
import { AuthGuardService } from './services/auth-guard-service';
import { CurrencyPipe } from './pipes/currency.pipe';
import { ErroComponent } from './app-views/errors/erro/erro.component';
import { FormTipoLaudoCarsysComponent } from './app-views/laudo-carsys/form-tipo-laudo-carsys/form-tipo-laudo-carsys.component';
import { ListTipoLaudoCarsysComponent } from './app-views/laudo-carsys/list-tipo-laudo-carsys/list-tipo-laudo-carsys.component';
import { PlacaPipe } from './pipes/placa.pipe';
import { PreviewCarComponent } from './app-views/laudo-union/components/preview-car/preview-car.component';
import { FormParecerLaudoComponent } from './app-views/laudo-union/form-laudo/form-parecer-laudo/form-parecer-laudo.component';
import { SidePreviewComponent } from './app-views/laudo-union/components/side-preview/side-preview.component';
import { ModalFotosConsultaComponent } from './app-views/consulta-resultado/modal-fotos-consulta/modal-fotos-consulta.component';
import { ModalEditarConsultaComponent } from './app-views/consulta-resultado/modal-editar-consulta/modal-editar-consulta.component';
import { RelatorioLaudoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo.component';
import { PreviewCarFullComponent } from './app-views/laudo-union/components/preview-car-full/preview-car-full.component';
import { ListaImgComponent } from './app-views/laudo-union/relatorio-laudo/components/lista-img/lista-img.component';
import { ListaTituloDescComponent } from './app-views/laudo-union/relatorio-laudo/components/lista-titulo-desc/lista-titulo-desc.component';
import { ListaPadraoComponent } from './app-views/laudo-union/relatorio-laudo/components/lista-padrao/lista-padrao.component';
import { CardRelatorioLaudoComponent } from './app-views/laudo-union/relatorio-laudo/components/card-relatorio-laudo/card-relatorio-laudo.component';
import { ConsultaCotacaoSeguroComponent } from './app-views/consulta-resultado/consultas/consulta-cotacao-seguro/consulta-cotacao-seguro.component';
import { ListNovaAssociacaoAuditorComponent } from './app-views/auditoria/auditor/list-nova-associacao-auditor/list-nova-associacao-auditor.component';
import { FormNovaAssociacaoComponent } from './app-views/auditoria/auditor/form-nova-associacao/form-nova-associacao.component';
import { ListAssociacaoAuditorComponent } from './app-views/auditoria/auditor/list-associacao-auditor/list-associacao-auditor.component';
import { RelatorioLaudoProprietarioComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-proprietario/relatorio-laudo-proprietario.component';
import { RelatorioLaudoVistoriaComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-vistoria/relatorio-laudo-vistoria.component';
import { RelatorioLaudoEtiquetasComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-etiquetas/relatorio-laudo-etiquetas.component';
import { RelatorioLaudoVidrosComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-vidros/relatorio-laudo-vidros.component';
import { RelatorioLaudoPinturaComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-pintura/relatorio-laudo-pintura.component';
import { RelatorioLaudoEstruturaComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-estrutura/relatorio-laudo-estrutura.component';
import { RelatorioLaudoIdentificacaoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-identificacao/relatorio-laudo-identificacao.component';
import { RelatorioLaudoVeiculoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-veiculo/relatorio-laudo-veiculo.component';
import { RelatorioLaudoDadosVeiculoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-dados-veiculo/relatorio-laudo-dados-veiculo.component';
import { RelatorioLaudoPadraoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-padrao/relatorio-laudo-padrao.component';
import { RelatorioLaudoResumoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-resumo/relatorio-laudo-resumo.component';
import { RelatorioLaudoResumoListaComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo-resumo-lista/relatorio-laudo-resumo-lista.component';
import { HeaderRelatorioLaudoComponent } from './app-views/laudo-union/relatorio-laudo/components/header-relatorio-laudo/header-relatorio-laudo.component';
import { HeaderTopComponent } from './app-views/laudo-union/relatorio-laudo/components/header-top/header-top.component';
import { HeaderQrcodeComponent } from './app-views/laudo-union/relatorio-laudo/components/header-qrcode/header-qrcode.component';
import { HeaderPlacaComponent } from './app-views/laudo-union/relatorio-laudo/components/header-placa/header-placa.component';
import { ListPontoAtendimentoComponent } from './app-views/unidade/list-ponto-atendimento/list-ponto-atendimento.component';
import { ListUnidadesAtendidasComponent } from './app-views/unidade/list-unidades-atendidas/list-unidades-atendidas.component';
import { ListaConsultasCiacComponent } from './app-views/ciac/consultas/lista-consultas-ciac/lista-consultas-ciac.component';
import { FormConsultasCiacComponent } from './app-views/ciac/consultas/form-consultas-ciac/form-consultas-ciac.component';
import { DcsComponent } from './app-views/ciac/consultas/dcs/dcs.component';
import { HistoricoDcsComponent } from './app-views/ciac/consultas/dcs/components/historico-dcs/historico-dcs.component';
import { ListaFornecedoresCiacComponent } from './app-views/ciac/fornecedores/lista-fornecedores-ciac/lista-fornecedores-ciac.component';
import { FormFornecedoresCiacComponent } from './app-views/ciac/fornecedores/form-fornecedores-ciac/form-fornecedores-ciac.component';
import { CnpjPipe } from './pipes/cnpj.pipe';
import { ListaConsultasFornecedoresComponent } from './app-views/ciac/consultas-fornecedores/lista-consultas-fornecedores/lista-consultas-fornecedores.component';
import { FormConsultasFornecedoresComponent } from './app-views/ciac/consultas-fornecedores/form-consultas-fornecedores/form-consultas-fornecedores.component';
import { ListaConversoesComponent } from './app-views/ciac/conversoes/lista-conversoes/lista-conversoes.component';
import { FormConversoesComponent } from './app-views/ciac/conversoes/form-conversoes/form-conversoes.component';
import { ConsultaResultadoCiacComponent } from './app-views/ciac/consulta-resultado-ciac/consulta-resultado-ciac.component';
import { DceComponent } from './app-views/ciac/consultas-fornecedores/dce/dce.component';
import { HistoricoDceComponent } from './app-views/ciac/consultas-fornecedores/dce/components/historico-dce/historico-dce.component';
import { ConsultaIdentificacaoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-identificacao/consulta-identificacao.component';
import { ConsultaLocalizacaoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-localizacao/consulta-localizacao.component';
import { ResumoResultadoComponent } from './app-views/ciac/consulta-resultado-ciac/resumo-resultado/resumo-resultado.component';
import { ConsultaGrafiasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-grafias/consulta-grafias.component';
import { ConsultasRealizadasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consultas-realizadas/consultas-realizadas.component';
import { ConsultaReferenciaNegociosComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-referencia-negocios/consulta-referencia-negocios.component';
import { ConsultaPendenciasFinanceirasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-pendencias-financeiras/consulta-pendencias-financeiras.component';
import { ConsultaRegistroDebitoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-registro-debito/consulta-registro-debito.component';
import { ConsultaHistoricoEnderecoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-historico-endereco/consulta-historico-endereco.component';
import { ConsultaHistoricoPagamentoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-historico-pagamento/consulta-historico-pagamento.component';
import { ConsultaProtestoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-protesto/consulta-protesto.component';
import { ConsultaCapitalSocialComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-capital-social/consulta-capital-social.component';
import { ConsultaQuadroAdmComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-quadro-adm/consulta-quadro-adm.component';
import { ConsultaControleSocietarioComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-controle-societario/consulta-controle-societario.component';
import { ConsultaUltimasConsultasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-ultimas-consultas/consulta-ultimas-consultas.component';
import { ConsultaHistoricoConsultasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-historico-consultas/consulta-historico-consultas.component';
import { ConsultaLimiteCreditoPjComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-limite-credito-pj/consulta-limite-credito-pj.component';
import { ConsultaRestricoesFinanceirasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-restricoes-financeiras/consulta-restricoes-financeiras.component';
import { ConsultaCcfComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-ccf/consulta-ccf.component';
import { ConsultaScpcBvsComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-scpc-bvs/consulta-scpc-bvs.component';
import { ConsultaParticipacaoEmpresasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-participacao-empresas/consulta-participacao-empresas.component';
import { ConsultaAnterioresSinteticoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-anteriores-sintetico/consulta-anteriores-sintetico.component';
import { ConsultaAnterioresAnaliticoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-anteriores-analitico/consulta-anteriores-analitico.component';
import { ConsultaChequeOrdemOcorrenciasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-cheque-ordem-ocorrencias/consulta-cheque-ordem-ocorrencias.component';
import { ConsultaRelatorioUnificadoCpfComponent } from './app-views/ciac/consulta-resultado-ciac/consultas/consulta-relatorio-unificado-cpf/consulta-relatorio-unificado-cpf.component';
import { ConsultaRelatorioUnificadoCnpjComponent } from './app-views/ciac/consulta-resultado-ciac/consultas/consulta-relatorio-unificado-cnpj/consulta-relatorio-unificado-cnpj.component';
import { ConsultaRelatorioSinteticoPlusCpfComponent } from './app-views/ciac/consulta-resultado-ciac/consultas/consulta-relatorio-sintetico-plus-cpf/consulta-relatorio-sintetico-plus-cpf.component';
import { ConsultaRelatorioSinteticoPlusCnpjComponent } from './app-views/ciac/consulta-resultado-ciac/consultas/consulta-relatorio-sintetico-plus-cnpj/consulta-relatorio-sintetico-plus-cnpj.component';
import { IdentificacaoCpfComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/identificacao-cpf/identificacao-cpf.component';
import { ProtestoEstadualComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/protesto-estadual/protesto-estadual.component';
import { IdentificacaoCnpjComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/identificacao-cnpj/identificacao-cnpj.component';
import { AlertasComponent } from './app-views/ciac/consulta-resultado-ciac/components/alertas/alertas.component';
import { FooterComponent } from './app-views/ciac/consulta-resultado-ciac/components/footer/footer.component';
import { ConsultaRendaPresumidaComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-renda-presumida/consulta-renda-presumida.component';
import { ConsultaAnterioresScpcComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-anteriores-scpc/consulta-anteriores-scpc.component';
import { ConsultaScoreComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-score/consulta-score.component';
import { DateIntervalComponent } from './app-components/date-interval/date-interval.component';
import { UtilValidators } from 'src/app/utils/util-validators';

import { FooterConsultaComponent } from './app-views/consulta-resultado/footer-consulta/footer-consulta.component';
import { ConsultaDividasVencidasComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-dividas-vencidas/consulta-dividas-vencidas.component';
import { ConsultasAnterioresComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consultas-anteriores/consultas-anteriores.component';
import { FaturamentoComponent } from './app-views/faturamento/faturamento.component';
import { FaturamentoDetalhamentoComponent } from './app-views/faturamento-detalhamento/faturamento-detalhamento.component';
import { FaturamentoDetalhamentoClienteComponent } from './app-views/faturamento-detalhamento-cliente/faturamento-detalhamento-cliente.component';
import { ConsultaChequeSemFundoComponent } from './app-views/ciac/consulta-resultado-ciac/consultas-filhas-components/consulta-cheque-sem-fundo/consulta-cheque-sem-fundo.component';
import { ConsultaProprietarioLicenciamentoComponent } from './app-views/consulta-resultado/consultas/consulta-proprietario-licenciamento/consulta-proprietario-licenciamento.component';
import { ConsultaPrecificadorDecisaoCertaComponent } from './app-views/consulta-resultado/consultas/consulta-precificador-decisao-certa/consulta-precificador-decisao-certa.component';
import { ModalMsgQuestionComponent } from './app-components/modal-msg-question/modal-msg-question.component';
import { ConsultaCrlvEComponent } from './app-views/consulta-resultado/consultas/consulta-crlv-e/consulta-crlv-e.component';
import { ConsultaDetranscComponent } from './app-views/consulta-resultado/consultas/consulta-detransc/consulta-detransc.component';
import { ConsultaDetranPrComponent } from './app-views/consulta-resultado/consultas/consulta-detran-pr/consulta-detran-pr.component';
import { ConsultaBateuPrComponent } from './app-views/consulta-resultado/consultas/consulta-bateu-pr/consulta-bateu-pr.component';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { PickListModule } from 'primeng/picklist';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ServicosComponent } from './app-views/servicos/servicos.component';
import { MeuFaturamentoComponent } from './app-views/faturamento/meu-faturamento/meu-faturamento.component';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { DropdownModule } from 'primeng/dropdown';
import { DadosBlocoDetranComponent } from './app-views/consulta-resultado/card-consulta/dados-bloco-detran/dados-bloco-detran.component';
import { DadosBlocoSenatranComponent } from './app-views/consulta-resultado/card-consulta/dados-bloco-senatran/dados-bloco-senatran.component';
import { CkSelectComponent } from './app-views/consulta-resultado/card-consulta/ck-select/ck-select.component';
import { KnobModule } from 'primeng/knob';
import { KnobCronComponent } from './app-components/knob-cron/knob-cron.component';
import { InformativoComponent } from './app-views/laudo-union/relatorio-laudo/components/informativo/informativo.component';
import { ConsultaCsvComponent } from './app-views/consulta-resultado/consultas/consulta-csv/consulta-csv.component';
import { ConsultaHistoricoRFProComponent } from './app-views/consulta-resultado/consultas/consulta-historico-rf-pro/consulta-historico-rf-pro.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormHgLaudoComponent } from './app-views/laudo-union/form-laudo/form-hg-laudo/form-hg-laudo.component';
import { ModalMotivoBloqueioComponent } from './app-components/modal-motivo-bloqueio/modal-motivo-bloqueio.component';
import { ModalEditarVistoriadorComponent } from './app-views/laudo-union/modal-editar-vistoriador/modal-editar-vistoriador.component';
import { FormRealizarConsultaLaudoComponent } from './app-views/laudo-union/form-laudo/form-realizar-consulta-laudo/form-realizar-consulta-laudo.component';
import { ModalEditarDataVistoriaComponent } from './app-views/laudo-union/modal-editar-data-vistoria/modal-editar-data-vistoria.component';
import { ExcelService } from './services/excel.service';
import { ModalUploadLoteComponent } from './app-views/laudo-union/modal-upload-lote/modal-upload-lote.component';
import { ConsultaExperimentalComponent } from './app-views/consulta-resultado/consultas/consulta-experimental/consulta-experimental.component';


import { HeaderConsultaComponent } from './app-views/consulta-resultado/header-consulta/header-consulta.component';
import { HomeViewComponent } from './app-views/landing-page/home-view/home-view.component';
import { InstitucionalViewComponent } from './app-views/landing-page/institucional-view/institucional-view.component';
import { SolucoesComponent } from './app-views/landing-page/solucoes/solucoes.component';
import { UnidadesComponent } from './app-views/landing-page/unidades/unidades.component';
import { AreasDeAtuacaoComponent } from './app-views/landing-page/areas-de-atuacao/areas-de-atuacao.component';
import { BlogComponent } from './app-views/landing-page/blog/blog.component';
import { ContatoComponent } from './app-views/landing-page/contato/contato.component';
import { LandingMenuComponent } from './navigation/landing-menu/landing-menu.component';
import { SolutionsComponent } from './app-views/landing-page/home-view/solutions/solutions.component';
import { ConsultsComponent } from './app-views/landing-page/home-view/consults/consults.component';
import { DiferentialsComponent } from './app-views/landing-page/home-view/diferentials/diferentials.component';
import { ContactBoxComponent } from './app-views/landing-page/home-view/contact-box/contact-box.component';
import { TestimonialsComponent } from './app-views/landing-page/home-view/testimonials/testimonials.component';
import { DestaqueBlogComponent } from './app-views/landing-page/home-view/destaque-blog/destaque-blog.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';
import { PoliticasDeCookiesComponent } from './landing-footer/politicas-de-cookies/politicas-de-cookies.component';
import { PoliticasDePrivacidadeComponent } from './landing-footer/politicas-de-privacidade/politicas-de-privacidade.component';
import { AppearOnScrollDirective } from './directives/appear-on-scroll.directive';
import { AppearRightOnScrollDirective } from './directives/appearRight-on-scroll.directive';
import { CanetaComponent } from './app-views/landing-page/solucoes/caneta/caneta.component';
import { ConsultaComponent } from './app-views/landing-page/solucoes/consulta/consulta.component';
import { CreditoComponent } from './app-views/landing-page/solucoes/credito/credito.component';
import { DecisaoCertaComponent } from './app-views/landing-page/solucoes/decisao-certa/decisao-certa.component';
import { EcvsComponent } from './app-views/landing-page/solucoes/ecvs/ecvs.component';
import { GestaoComponent } from './app-views/landing-page/solucoes/gestao/gestao.component';
import { VistoriaAutonomaComponent } from './app-views/landing-page/solucoes/vistoria-autonoma/vistoria-autonoma.component';
import { VistoriaCautelarComponent } from './app-views/landing-page/solucoes/vistoria-cautelar/vistoria-cautelar.component';
import { VistoriaVeicularComponent } from './app-views/landing-page/solucoes/vistoria-veicular/vistoria-veicular.component';
import { UniversidadeDoCarroComponent } from './app-views/landing-page/solucoes/universidade-do-carro/universidade-do-carro.component';
import { CompraComponent } from './app-views/landing-page/solucoes/caneta/compra/compra.component';
import { ConsultaVeicularComponent } from './app-views/landing-page/solucoes/consulta/consulta-veicular/consulta-veicular.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PostViewComponent } from './app-views/landing-page/blog/post-view/post-view.component';
import { ExemploDecisaoCertaComponent } from './app-views/landing-page/solucoes/decisao-certa/exemplo-decisao-certa/exemplo-decisao-certa.component';
import { ExemploVistoriaCautelarComponent } from './app-views/landing-page/solucoes/vistoria-cautelar/exemplo-vistoria-cautelar/exemplo-vistoria-cautelar.component';
import { ConfirmarEmailComponent } from './app-views/usuario/confirmar-email/confirmar-email.component';
import { AutorizarDispositivoComponent } from './app-views/usuario/autorizar-dispositivo/autorizar-dispositivo.component';
import { ExemploVistoriaAutonomaComponent } from './app-views/landing-page/solucoes/vistoria-autonoma/exemplo-vistoria-autonoma/exemplo-vistoria-autonoma.component';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    SideMenuComponent,
    BrandLogoComponent,
    SideNavItemComponent,
    SideNavDropdownComponent,
    TopMenuComponent,
    AppCheckboxComponent,
    HomeComponent,
    AppInputRadioComponent,
    RealizarConsultaComponent,
    AppInputToggleComponent,
    FormConsultaCompostaComponent,
    ListConsultaCompostaComponent,
    ListHistoricoConsultaComponent,
    LoginComponent,
    RecuperarSenhaComponent,
    FormRealizarConsultaComponent,
    MsgErroComponent,
    ModalFormRealizarConsultaComponent,
    ModalSenhaExpiradaComponent,
    ModalLoadingComponent,
    ModalMsgComponent,
    ModalJustificativaComponent,
    ModalMotivoBloqueioComponent,
    ResgateConsultaComponent,
    FormUnidadeComponent,
    ListUnidadeComponent,
    ListUsuarioComponent,
    FormUsuarioComponent,
    FormNovaSenhaComponent,
    ListTipoUnidadeComponent,
    FormTipoUnidadeComponent,
    ConsultaResultadoComponent,
    ResumoDecisaoCertaComponent,
    CardConsultaComponent,
    ConsultaAgregadosComponent,
    ConsultaDadosEstaduaisComponent,
    ConsultaDadosNacionaisComponent,
    ConsultaDadosRenajudComponent,
    ConsultaDecodificadorChassiComponent,
    ConsultaGravameComponent,
    ConsultaHistoricoProprietarioComponent,
    ConsultaHistoricoProprietarioSimplificadoComponent,
    ConsultaHistoricoVendaComponent,
    ConsultaRouboFurtoComponent,
    ConsultaIndicioSinistroComponent,
    ConsultaDuplicidadeChassiMotorComponent,
    ConsultaLocalizaPlacaComponent,
    ConsultaPrecificadorComponent,
    ConsultaRecallComponent,
    ConsultaRenavamComponent,
    SinalizadorNivelComponent,
    ConsultaLeilaoComponent,
    ConsultaLeilaoComplementarComponent,
    ConsultaPrecoMolicarComponent,
    ConsultaPrecoKbbComponent,
    ConsultaPrecoWebmotorsComponent,
    ConsultaDesvalorizacaoMediaComponent,
    ConsultaParecerTecnicoComponent,
    ConsultaGenericaComponent,
    ConsultaCnhComponent,
    ConsultaCrlvComponent,
    ConsultaDadosHistoricoComponent,
    TableTitleOrderComponent,
    RelatorioProducaoComponent,
    RelatorioUnidadeComponent,
    RelatorioWebSocketComponent,
    RelatorioConsultasRealizadasComponent,
    ConsultaPtComponent,
    ConsultaLocalizadorVeiculoComponent,
    ConsultaMultaRenainfComponent,
    UploadLaudoComponent,
    ListLaudoCarsysComponent,
    FormTabelaPrecoComponent,
    ListTabelaPrecoComponent,
    ListTabelaPrecoLaudoComponent,
    FormTabelaPrecoLaudoComponent,
    InputRangeQuantidadePrecoComponent,
    ListConsultaLoteComponent,
    FormConsultaLoteComponent,
    VisualizarConsultaLoteComponent,
    StepByStepComponent,
    FormLaudoComponent,
    ImageEditorComponent,
    ImageEditorModalComponent,
    InputFileComponent,
    InputImgLaudoComponent,
    InputTextLaudoComponent,
    InputSelectLaudoComponent,
    CardCollapseComponent,
    ListLaudoUnionComponent,
    ListConfigLaudoUnionComponent,
    FormConfigLaudoUnionComponent,
    ListLaudosAgendadosComponent,
    FormAgendamentoLaudoUnionComponent,
    FormNovoLaudoComponent,
    FormImgLaudoComponent,
    FormAssociacaoAuditoriaComponent,
    ListAssociacaoAuditoriaComponent,
    ListNovaAssociacaoAuditoraComponent,
    AuditarLaudoAuditoriaComponent,
    TemplateBuilderComponent,
    ElementTemplateBuilderComponent,
    FormModalImgLaudoComponent,
    FormImgAdicionalLaudoComponent,
    CurrencyPipe,
    ErroComponent,
    FormTipoLaudoCarsysComponent,
    ListTipoLaudoCarsysComponent,
    PlacaPipe,
    CnpjPipe,
    PreviewCarComponent,
    FormParecerLaudoComponent,
    SidePreviewComponent,
    ModalFotosConsultaComponent,
    ModalEditarConsultaComponent,
    RelatorioLaudoComponent,
    PreviewCarFullComponent,
    ListaImgComponent,
    ListaTituloDescComponent,
    ListaPadraoComponent,
    CardRelatorioLaudoComponent,
    ConsultaCotacaoSeguroComponent,
    ListNovaAssociacaoAuditorComponent,
    FormNovaAssociacaoComponent,
    ListAssociacaoAuditorComponent,
    RelatorioLaudoProprietarioComponent,
    RelatorioLaudoVistoriaComponent,
    RelatorioLaudoEtiquetasComponent,
    RelatorioLaudoVidrosComponent,
    RelatorioLaudoPinturaComponent,
    RelatorioLaudoEstruturaComponent,
    RelatorioLaudoIdentificacaoComponent,
    RelatorioLaudoVeiculoComponent,
    RelatorioLaudoDadosVeiculoComponent,
    RelatorioLaudoPadraoComponent,
    RelatorioLaudoResumoComponent,
    RelatorioLaudoResumoListaComponent,
    ListUnidadesAuditadasComponent,
    HeaderRelatorioLaudoComponent,
    HeaderTopComponent,
    HeaderQrcodeComponent,
    HeaderPlacaComponent,
    ListPontoAtendimentoComponent,
    ListUnidadesAtendidasComponent,
    ListaConsultasCiacComponent,
    FormConsultasCiacComponent,
    DcsComponent,
    HistoricoDcsComponent,
    ListaFornecedoresCiacComponent,
    FormFornecedoresCiacComponent,
    ListaConsultasFornecedoresComponent,
    FormConsultasFornecedoresComponent,
    ListaConversoesComponent,
    FormConversoesComponent,
    ConsultaResultadoCiacComponent,
    DceComponent,
    HistoricoDceComponent,
    ConsultaIdentificacaoComponent,
    ConsultaLocalizacaoComponent,
    ResumoResultadoComponent,
    ConsultaGrafiasComponent,
    ConsultasRealizadasComponent,
    ConsultaReferenciaNegociosComponent,
    ConsultaPendenciasFinanceirasComponent,
    ConsultaRegistroDebitoComponent,
    ConsultaHistoricoEnderecoComponent,
    ConsultaHistoricoPagamentoComponent,
    ConsultaProtestoComponent,
    ConsultaCapitalSocialComponent,
    ConsultaQuadroAdmComponent,
    ConsultaControleSocietarioComponent,
    ConsultaUltimasConsultasComponent,
    ConsultaHistoricoConsultasComponent,
    ConsultaLimiteCreditoPjComponent,
    ConsultaRestricoesFinanceirasComponent,
    ConsultaCcfComponent,
    ConsultaScpcBvsComponent,
    ConsultaParticipacaoEmpresasComponent,
    ConsultaAnterioresSinteticoComponent,
    ConsultaAnterioresAnaliticoComponent,
    ConsultaChequeOrdemOcorrenciasComponent,
    ConsultaRelatorioUnificadoCpfComponent,
    ConsultaRelatorioUnificadoCnpjComponent,
    ConsultaRelatorioSinteticoPlusCpfComponent,
    ConsultaRelatorioSinteticoPlusCnpjComponent,
    IdentificacaoCpfComponent,
    ProtestoEstadualComponent,
    IdentificacaoCnpjComponent,
    AlertasComponent,
    FooterComponent,
    ConsultaRendaPresumidaComponent,
    ConsultaAnterioresScpcComponent,
    ConsultaScoreComponent,
    DateIntervalComponent,

    FooterConsultaComponent,
    ConsultaDividasVencidasComponent,
    ConsultasAnterioresComponent,

    FaturamentoComponent,
    FaturamentoDetalhamentoComponent,
    FaturamentoDetalhamentoClienteComponent,
    ConsultaChequeSemFundoComponent,
    ConsultaProprietarioLicenciamentoComponent,
    ConsultaPrecificadorDecisaoCertaComponent,

    ConsultaCrlvEComponent,
    ConsultaDetranscComponent,
    ConsultaDetranPrComponent,
    ConsultaBateuPrComponent,

    ModalMsgQuestionComponent,

    ServicosComponent,
    MeuFaturamentoComponent,
    DadosBlocoDetranComponent,
    DadosBlocoSenatranComponent,
    CkSelectComponent,
    KnobCronComponent,
    InformativoComponent,
    ConsultaCsvComponent,
    ConsultaHistoricoRFProComponent,
    ConsultaExperimentalComponent,
    FormHgLaudoComponent,
    FormRealizarConsultaLaudoComponent,
    ModalEditarVistoriadorComponent,
    ModalEditarDataVistoriaComponent,
    ModalUploadLoteComponent,
    ConsultaExperimentalComponent,


    HeaderConsultaComponent,

    LandingMenuComponent,
    HomeViewComponent,
    SolutionsComponent,
    ConsultsComponent,
    DiferentialsComponent,
    TestimonialsComponent,
    DestaqueBlogComponent,
    ContactBoxComponent,
    InstitucionalViewComponent,
    SolucoesComponent,
    CanetaComponent,
    ConsultaComponent,
    CreditoComponent,
    DecisaoCertaComponent,
    EcvsComponent,
    GestaoComponent,
    VistoriaAutonomaComponent,
    VistoriaCautelarComponent,
    VistoriaVeicularComponent,
    UniversidadeDoCarroComponent,
    ExemploDecisaoCertaComponent,
    ExemploVistoriaCautelarComponent,
    UnidadesComponent,
    AreasDeAtuacaoComponent,
    BlogComponent,
    ContatoComponent,
    LandingFooterComponent,
    PoliticasDeCookiesComponent,
    PoliticasDePrivacidadeComponent,
    AppearOnScrollDirective,
    AppearRightOnScrollDirective,
    CompraComponent,
    ConsultaVeicularComponent,
    PostViewComponent,
    ModalSenhaExpiradaComponent,
    ConfirmarEmailComponent,
    AutorizarDispositivoComponent,
    ExemploVistoriaAutonomaComponent


  ],
  entryComponents: [
    ModalFormRealizarConsultaComponent, ModalLoadingComponent, ModalMsgComponent, ModalJustificativaComponent, ModalMsgQuestionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    FileUploadModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbModalModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbPopoverModule,
    HttpClientModule,
    ReactiveFormsModule,
    TextMaskModule,
    QRCodeModule,
    ImageCropperModule,
    PaginatorModule,
    TableModule,
    MultiSelectModule,
    PickListModule,
    ConfirmDialogModule,
    CalendarModule,
    TooltipModule,
    OverlayPanelModule,
    DialogModule,
    NgxMaskModule.forRoot(options),
    AgmCoreModule.forRoot({ apiKey: EnderecoService.GOOGLE_API_KEY }),
    DropdownModule,
    KnobModule,
    SelectButtonModule,
    RouterModule,
    PaginationModule.forRoot()


  ],
  providers: [
    FormBuilder,
    LoginService,
    HttpClient,
    AuthGuardService,
    UtilValidators,
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: NgbDateBrParserFormatter },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    UtilForms,
    KnobCronComponent,
    ExcelService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
